import { useSelector } from "react-redux";
import StatusChip from "@entrilia/shared/components/StatusChip";
import { getCategoryTagColor } from "@entrilia/shared/utilities/categoryColor";
import { categoryTagsSelector } from "../../store/state/inboxStructure/selectors";
import { filterCategoriesMapSelector } from "../../store/state/messages/selectors";

interface Props {
  categoryId: string;
}

const MessageCategoryTag = ({ categoryId }: Props) => {
  const categoriesMap = useSelector(filterCategoriesMapSelector);
  const categoryTags = useSelector(categoryTagsSelector);
  const categoryName = categoriesMap.get(categoryId);

  if (!categoryName) {
    return null;
  }

  const categoryTag = categoryTags.find((c) => c.id === categoryId);

  return <StatusChip label={categoryName} color={getCategoryTagColor(categoryTag?.color)} />;
};

export default MessageCategoryTag;
